import axios from "axios";
import { getAccessToken } from "./cookies";

export const API_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_PUBLIC_DEV_API_URL
    : process.env.REACT_APP_PUBLIC_PROD_API_URL;

const postAPICall = (url: string, data: any) => {
  return axios.post(url, data, {
    headers: {
      withCredentials: true,
    },
  });
};

const getAPICall = (url: string) => {
  return axios.get(url, {
    headers: {
      withCredentials: true,
    },
  });
};

const postAPICallServer = async (url: string, data: any, req: any = {}) => {
  try {
    const result: any = await axios.post(`${API_URL}${url}`, data, {
      headers: {
        withCredentials: true,
        ["X-Authorization"]: getAccessToken(),
        ...(req?.headers?.cookie ? { Cookie: req?.headers?.cookie } : {}),
      },
    });

    if (result?.data) return result;
    else throw result;
  } catch (err: any) {
    if (err?.response?.data?.statusCode === 401) {
      window.location.href = "/logout";
    }
    throw err;
  }
};

const getAPICallServer = async (url: string, req: any = {}) => {
  try {
    const result: any = await axios.get(`${API_URL}${url}`, {
      headers: {
        withCredentials: true,
        ["X-Authorization"]: getAccessToken(),
        ...(req?.headers?.cookie ? { Cookie: req?.headers?.cookie } : {}),
      },
    });

    if (result?.data) return result;
    else throw result;
  } catch (err: any) {
    if (err?.response?.data?.statusCode === 401) {
      window.location.href = "/logout";
    }
    throw err;
  }
};

const deleteAPICallServer = async (url: string, req: any = {}) => {
  try {
    const result: any = await axios.delete(`${API_URL}${url}`, {
      headers: {
        withCredentials: true,
        ["X-Authorization"]: getAccessToken(),
        ...(req?.headers?.cookie ? { Cookie: req?.headers?.cookie } : {}),
      },
    });
    if (result?.data) return result;
    else throw result;
  } catch (err: any) {
    if (err?.response?.data?.statusCode === 401) {
      window.location.href = "/logout";
    }
    throw err;
  }
};

const putAPICallServer = async (url: string, data: any, req: any = {}) => {
  try {
    const result: any = await axios.put(`${API_URL}${url}`, data, {
      headers: {
        withCredentials: true,
        ["X-Authorization"]: getAccessToken(),
        ...(req?.headers?.cookie ? { Cookie: req?.headers?.cookie } : {}),
      },
    });

    if (result?.data) return result;
    else throw result;
  } catch (err: any) {
    if (err?.response?.data?.statusCode === 401) {
      window.location.href = "/logout";
    }
    throw err;
  }
};

export {
  postAPICall,
  postAPICallServer,
  getAPICallServer,
  getAPICall,
  deleteAPICallServer,
  putAPICallServer,
};
